import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/calendar-accounts/{calendarAccountId}/calendars/{calendarId}']['PUT'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const enableCalendar = async ({ calendarAccountId, calendarId }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/calendar-accounts/${calendarAccountId}/calendars/${calendarId}`, {
    isEnabled: true,
  });
  return response.data;
};

export default enableCalendar;
